
















import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import feedbackList from '@/views/myFeedbacks/components/feedbackList.vue';
import { getUrlParam } from '@/utils/util';
@Component({ components: { feedbackList } })
export default class MyFeedBackIndex extends Vue {
  loading: boolean = false;
  finished: boolean = false;
  activeName: string = '班次评价';
  feedbackStatus: string = '班次评价';
  listData: any = [];
  stateSwtich(name: string) {
    this.feedbackStatus = name;
    // this.getlistData(name);
  }
  mounted() {
    //评价成功，返回到已评教师或综合
    if (this.$route.params.feedbackStatus) {
      this.feedbackStatus = this.$route.params.feedbackStatus;
      this.activeName = this.feedbackStatus;
    }

    const type = Number(getUrlParam('type'));

    if (type == 2) {
      this.feedbackStatus = '教师评价';
      this.activeName = '教师评价';
    }
    // this.getlistData(this.feedbackStatus);
  }

  //获取待评或已评教师数据
  // async getlistData(crrStatu: string) {
  //   this.loading = true;
  //   this.listData = [];
  //   if (crrStatu == '待评教师') {
  //     try {
  //       const { data } = await api.TeacherEvaluation.getMyWaitEvaluate_GET();
  //       this.listData = data;
  //     } finally {
  //       this.loading = false;
  //       this.finished = true;
  //     }
  //   } else if (crrStatu == '已评教师') {
  //     try {
  //       const { data } = await api.TeacherEvaluation.getMyCommented_GET();
  //       this.listData = data;
  //     } finally {
  //       this.loading = false;
  //       this.finished = true;
  //     }
  //   } else if (crrStatu == '待评综合') {
  //     try {
  //       const { data } = await api.ComperhensiveEvaluation.getMyWaitEvaluate_GET();
  //       this.listData = data;
  //     } finally {
  //       this.loading = false;
  //       this.finished = true;
  //     }
  //   } else if (crrStatu == '已评综合') {
  //     try {
  //       const { data } = await api.ComperhensiveEvaluation.getMyCommented_GET();
  //       this.listData = data;
  //     } finally {
  //       this.loading = false;
  //       this.finished = true;
  //     }
  //   }
  // }
}
